import styled from "styled-components";

export const FormElement = styled.form`
  width: 100%;
  text-align: center;
  text-align: -webkit-center;
`;

export const ButtonElement = styled.button`
  background: transparent;
  border: transparent;
  margin-top: 10px;
`;
